<style scoped>

</style>
<template>
  <div>
    <v-row>
      <v-col>
        <v-autocomplete
          v-model="expense.expense_nature_id"
          :items="expense_natures"
          item-value="id"
          :item-text="expenseNatureText"
          :item-disabled="expenseNatureDisabled"
          label="费用 Nature"
          placeholder="请选择"
          clearable
          :filter="expenseNatureFilter"
          @click:clear="$nextTick(() => {expense.expense_nature_id = 0})"
          @change="calcAccountAndAnalysisTitle('expense_nature_id')"
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="expense.customer_function_id"
          :items="filter_customer_functions"
          item-value="id"
          :item-text="(i) => (`${i.name}${i.del ? '(已废弃)' : ''}`)"
          item-disabled="del"
          label="职能"
          :placeholder="filter_customer_functions.length ? '请选择' : '无可选项'"
          clearable
          :disabled="!filter_customer_functions.length"
          @click:clear="$nextTick(() => {expense.customer_function_id = 0})"
          @change="calcAccountAndAnalysisTitle('customer_function_id')"
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="expense.customer_type"
          :items="filter_customer_types"
          item-value="value"
          item-text="label"
          label="员工类型"
          :placeholder="filter_customer_types.length ? '请选择' : '无可选项'"
          clearable
          :disabled="!filter_customer_types.length"
          @click:clear="$nextTick(() => {expense.customer_type = -1})"
          @change="calcAccountAndAnalysisTitle('customer_type')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-autocomplete
          v-model="expense.item_type_id"
          :items="filter_item_types"
          item-value="id"
          :item-text="(i) => (`${i.name}${i.del ? '(已废弃)' : ''}`)"
          item-disabled="del"
          label="产品类型"
          :placeholder="filter_item_types.length ? '请选择' : '无可选项'"
          clearable
          :disabled="!filter_item_types.length"
          @click:clear="$nextTick(() => {expense.item_type_id = 0})"
          @change="calcAccountAndAnalysisTitle('item_type_id')"
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="expense.fund_usage_id"
          :items="filter_fund_usages"
          item-value="id"
          :item-text="(i) => (`${i.name}${i.del ? '(已废弃)' : ''}`)"
          item-disabled="del"
          label="资金用途"
          :placeholder="filter_fund_usages.length ? '请选择' : '无可选项'"
          clearable
          :disabled="!filter_fund_usages.length"
          @click:clear="$nextTick(() => {expense.fund_usage_id = 0})"
          @change="calcAccountAndAnalysisTitle('fund_usage_id')"
        />
      </v-col>
      <v-col>
        <v-checkbox
          v-model="expense.is_insider_trading"
          label="内部交易"
          @change="calcAccountAndAnalysisTitle('is_insider_trading')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AccountTitleName
          :value="expense.account_title_id"
          type="select"
          label="会计科目"
          :rules="[v => v > 0 || title_error_msg]"
        />
      </v-col>
      <v-col>
        <AnalysisTitleName
          :value="expense.analysis_title_id"
          type="select"
          label="分析科目"
          :rules="[v => v > 0 || title_error_msg]"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import AccountTitleName from '../../../account_title/components/name';
  import AnalysisTitleName from '../../../analysis_title/components/name';
  import TitleMappingUtil, {judgeThisKey} from "../../../title_mapping/libs/util";
  import {mapGetters} from "vuex";
  const change_fields = [
    'expense_nature_id', 
    'customer_function_id', 
    'customer_type', // 员工类型
    'item_type_id',
    'fund_usage_id',
  ]
  const illegality_arr = [undefined, null, '']
  export default {
    components: { AccountTitleName, AnalysisTitleName },
    props: {
      expense: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        title_error_msg: '请通过费用Nature等字段匹配出科目'
      }
    },
    computed: {
      ...mapGetters('async', [
        'expense_natures',
        'customer_functions',
        'customer_functions_hash',
        'mapping_customer_types',
        'mapping_customer_types_hash',
        'item_types',
        'item_types_hash',
        'fund_usages',
        'fund_usages_hash',
        'title_mappings'
      ]),
      mapped_expense_nature_hash() {
        return Object.assign({}, ...this.title_mappings.map(obj => {
          const key = obj['expense_nature_id'];
          return {[key]: true};
        }));
      },
      filter_customer_functions() {
        return this.commonFilter('customer_function_id', 'customer_functions_hash', [
          'expense_nature_id'
        ]);
      },
      filter_customer_types() {
        return this.commonFilter('customer_type', 'mapping_customer_types_hash', [
          'expense_nature_id',
          'customer_function_id'
        ]);
      },
      filter_item_types() {
        return this.commonFilter('item_type_id', 'item_types_hash', [
          'expense_nature_id',
          'customer_function_id',
          'customer_type',
        ]);
      },
      filter_fund_usages() {
        return this.commonFilter('fund_usage_id', 'fund_usages_hash', [
          'expense_nature_id',
          'customer_function_id',
          'customer_type',
          'item_type_id',
        ]);
      }
    },
    created() {
      //
    },
    mounted() {
    
      //
    },
    methods: {
      commonFilter(id_key, hash_key, equal_keys = []) {
        const list = [];
        const pushed_ids = {};
        const hash = this[hash_key];
        for (const m of this.title_mappings) {
          const id = m[id_key];
          // if (id === 0) continue;
          if (this.isKeysEqual(m, equal_keys)) {
            if (!pushed_ids[id]) {
              pushed_ids[id] = true;
              const item = hash[id];
              if (item) {
                list.push(item);
              }
            }
          }
        }
        return list;
      },
      isKeysEqual(title_mapping, equal_keys = []) {
        const equal = true;
        for (const key of equal_keys) {

          if (judgeThisKey(this.expense, key) && title_mapping[key] !== this.expense[key]) {
            return false;
          }
        }
        return equal;
      },
      expenseNatureFilter(item, query_text) {
        const text = `${item.name} ${item.synonyms ? item.synonyms : ''}`;
        return text.includes(query_text);
      },
      expenseNatureMapped(item) {
        return this.mapped_expense_nature_hash[item.id];
      },
      expenseNatureText(item) {
        let text = item.name;
        if (item.del) {
          text += '(已废弃)';
        } else if (!this.expenseNatureMapped(item)) {
          text += '(未建立 mapping 关系)';
        }
        return text;
      },
      expenseNatureDisabled(item) {
        return item.del || !this.expenseNatureMapped(item);
      },
      // 费用nature等字段变化后，获取mapping关系所对应的科目
      calcAccountAndAnalysisTitle(key) {
        if (key) {
          let index = change_fields.indexOf(key) + 1
          while (index && change_fields[index]) {
            this.expense[change_fields[index]] = null
            index++
          }
        }
        const params = {}
        change_fields.forEach(item => {
          if (item !== 'customer_type') {
            params[item] = this.expense[item] || 0
          } else {
            params[item] = illegality_arr.includes(this.expense[item]) ? null : this.expense[item]
          }
        })
        const title_mapping = TitleMappingUtil.getByNatureObj({...this.expense, ...params});
        this.expense.account_title_id = title_mapping.account_title_id;
        this.expense.analysis_title_id = title_mapping.analysis_title_id;
      },
    }
  }
</script>
